import { render, staticRenderFns } from "./AddArticleCategorySidebar.vue?vue&type=template&id=56b57772&scoped=true"
import script from "./AddArticleCategorySidebar.vue?vue&type=script&lang=js"
export * from "./AddArticleCategorySidebar.vue?vue&type=script&lang=js"
import style0 from "./AddArticleCategorySidebar.vue?vue&type=style&index=0&id=56b57772&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b57772",
  null
  
)

export default component.exports